import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { statisticsQueryKeys } from "../query-keys/statistics.query-keys";
import {
  AcExpoDashboard,
  ExhibitorStatistics,
  ExhibitorStatisticsFilter,
  OrganiserStatistics,
  OrganiserStatisticsFilter,
  PlaceManagerStatistics,
  PlaceManagerStatisticsFilter,
  TourismOperatorStatistics,
  TourismOperatorStatisticsFilter,
} from "@ac-expo/api-types";

// Organiser Statistics
const getOrganiserStats = async (filter: OrganiserStatisticsFilter) => {
  const { data } = await privateAxios.get<OrganiserStatistics>(
    `/organiser/stats`,
    {
      params: filter,
    }
  );
  return data;
};

export const useGetOrganiserStatsQuery = (
  filter: OrganiserStatisticsFilter
) => {
  return useQuery({
    queryFn: () => getOrganiserStats(filter),
    queryKey: statisticsQueryKeys.organiser(filter),
  });
};

// Place Manager Statistics
const getPlaceManagerStats = async (filter: PlaceManagerStatisticsFilter) => {
  const { data } = await privateAxios.get<PlaceManagerStatistics>(
    `/place-manager/stats`,
    {
      params: filter,
    }
  );
  return data;
};

export const useGetPlaceManagerStatsQuery = (
  filter: PlaceManagerStatisticsFilter
) => {
  return useQuery({
    queryFn: () => getPlaceManagerStats(filter),
    queryKey: statisticsQueryKeys.placeManager(filter),
  });
};

// Exhibitor Statistics
const getExhibitorStats = async (filter: ExhibitorStatisticsFilter) => {
  const { data } = await privateAxios.get<ExhibitorStatistics>(
    `/exhibitor/stats`,
    {
      params: filter,
    }
  );
  return data;
};

export const useGetExhibitorStatsQuery = (
  filter: ExhibitorStatisticsFilter
) => {
  return useQuery({
    queryFn: () => getExhibitorStats(filter),
    queryKey: statisticsQueryKeys.exhibitor(filter),
  });
};

// Tourism Operator Statistics
const getTourismOperatorStats = async (
  filter: TourismOperatorStatisticsFilter
) => {
  const { data } = await privateAxios.get<TourismOperatorStatistics>(
    `/tourism-operator/stats`,
    {
      params: filter,
    }
  );
  return data;
};

export const useGetTourismOperatorStatsQuery = (
  filter: TourismOperatorStatisticsFilter
) => {
  return useQuery({
    queryFn: () => getTourismOperatorStats(filter),
    queryKey: statisticsQueryKeys.tourismOperator(filter),
  });
};

// AppMaker Statistics
const getAcExpoDashboard = async (from: number) => {
  const { data } = await privateAxios.get<AcExpoDashboard>(
    `/ac-expo/dashboard`,
    {
      params: { from },
    }
  );
  return data;
};

export const useGetAcExpoDashboardQuery = (from: number) => {
  return useQuery({
    queryFn: () => getAcExpoDashboard(from),
    queryKey: ["ac-expo-dashboard", from],
  });
};
